// import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// import { EntityService } from '../entity.service';
// import { FooterService } from 'app/layout/common/footer/footer.service';
// @Component({
//   selector: 'app-reviews',
//   templateUrl: './reviews.component.html',
//   styleUrls: ['./reviews.component.scss']
// })
// export class ReviewsComponent implements OnInit {
//   constructor(private _entityService: EntityService, private _changeDetectorRef: ChangeDetectorRef,public _footerService:FooterService) {}
//   rvw_vle;
//   sgtn_tx: string = '';
//   @Input() rvwData;
//   prvsRvwsLst
//   shwPrvsRvw: boolean = false;
//   addRvw: boolean = false;
//   edt_in = 0
//   shwDiv:boolean
//   ngOnInit(): void {
//     if (this.rvwData.hndlr_nm && this.rvwData.enty_ky) {
//       this.get_prvsFdbck(this.rvwData.hndlr_nm, this.rvwData.enty_ky);
//     }
//     else {
//       this.get_prvsFdbck('review', 1);
//     }
//     this._footerService.getReviewCtrl().subscribe((res)=>{
//       this.shwDiv=res;
//       this._changeDetectorRef.markForCheck();
//     })
//   }
//   reviewClick(vle) {
//     this.rvw_vle = vle;
//   }
  
//   sbmt() {

//     let postData = {
//       rvw_tx: this.sgtn_tx,
//       rtng_id: this.rvw_vle,
//       enty_ky: this.rvwData.enty_ky,
//       hndlr_nm: this.rvwData.hndlr_nm
//     }
//     if (this.edt_in == 0) {

//       this._entityService.add_rvw(postData).subscribe((res) => {
//         if (res['status'] == 200) {
//           this._entityService.openSnackBar(res['message'], 'mat-primary');
//           this.get_prvsFdbck(this.rvwData.hndlr_nm, this.rvwData.enty_ky);
//         }
//         else {
//           this._entityService.openSnackBar(res['message'], 'mat-warn');
//         }
//       })
//     }
//     else {
//       postData['rvw_id']=this.prvsRvwsLst[0].rvw_id;
//       this._entityService.updte_rvw(postData).subscribe((res)=>{
//         if(res['status'] == 200)
//         {
//           this._entityService.openSnackBar(res['message'], 'mat-primary');
//           this.get_prvsFdbck(this.rvwData.hndlr_nm, this.rvwData.enty_ky);
//         }
//         else
//         {
//           this._entityService.openSnackBar(res['message'], 'mat-warn');
//         }
//       })
//     }

//   }
//   get_prvsFdbck(hndlr_nm, enty_ky) {
//     this._entityService.get_prvsRvws(hndlr_nm, enty_ky).subscribe((res) => {
//       if (res['status'] == 200) {
//         if (res['data'].length > 0) {
//           this.prvsRvwsLst = res['data']
//           this.rvw_vle = this.prvsRvwsLst[0].rtng_id
//           this.sgtn_tx = this.prvsRvwsLst[0].rvw_tx
//           this.shwPrvsRvw = true;
//           this.addRvw = false;
//           this.edt_in=0;
//           this._changeDetectorRef.markForCheck();
//         }
//         else {
//           this.shwPrvsRvw = false;
//           this.addRvw = true;
//           this._changeDetectorRef.markForCheck();
//         }

//       }
//       else {
//         this._entityService.openSnackBar(res['message'], 'mat-warn');
//       }
//     })
//   }
//   edtCntct() {
//     this.addRvw = true;
//     this.shwPrvsRvw = false;
//     this.edt_in = 1;
//   }
//   Close() {
//     this.edt_in = 0;
//     this.rvw_vle = this.prvsRvwsLst[0].rtng_id
//     this.sgtn_tx = this.prvsRvwsLst[0].rvw_tx
//     this.shwPrvsRvw = true;
//     this.addRvw = false;
//     this._changeDetectorRef.markForCheck();
//   }

//   openPanel()
//   {
//     if(this.shwDiv)
//     {
//       this.shwDiv=false;
//     }
//     else
//     {
//       this.shwDiv=true;
//     }
//   }
// }


import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { Subject } from 'rxjs';
import { TemplatePortal } from '@angular/cdk/portal';
import { MatButton } from '@angular/material/button';
import { Shortcut } from 'app/layout/common/shortcuts/shortcuts.types';
import { ShortcutsService } from 'app/layout/common/shortcuts/shortcuts.service';
import { FooterService } from 'app/layout/common/footer/footer.service';
import { EntityService } from '../entity.service';
@Component({
    selector: 'app-reviews',
    templateUrl: './reviews.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'app-reviews'
})
export class ReviewsComponent implements OnInit, OnDestroy {
    mode: 'view' | 'modify' | 'add' | 'edit' = 'view';
    shortcuts: Shortcut[];
    private _overlayRef: OverlayRef;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    @ViewChild('shortcutsOrigin') private _shortcutsOrigin: MatButton;
    @ViewChild('shortcutsPanel') private _shortcutsPanel: TemplateRef<any>;

    rvw_vle;
    sgtn_tx: string = '';
    @Input() rvwData;
    prvsRvwsLst
    shwPrvsRvw: boolean = false;
    addRvw: boolean = false;
    edt_in = 0
    shwDiv:boolean
    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _shortcutsService: ShortcutsService,
        private _viewContainerRef: ViewContainerRef,
        private _overlay: Overlay,
        private _entityService: EntityService, public _footerService:FooterService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
      if (this.rvwData.hndlr_nm && this.rvwData.enty_ky) {
        this.get_prvsFdbck(this.rvwData.hndlr_nm, this.rvwData.enty_ky);
      }
      else {
        this.get_prvsFdbck('review', 1);
      }
      this._footerService.getReviewCtrl().subscribe((res)=>{
        this.shwDiv=res;
        this._changeDetectorRef.markForCheck();
      })
    }
  
    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

   
 
    /**
     * Create the overlay
     */
    private _createOverlay(): void {
        // Create the overlay
        this._overlayRef = this._overlay.create({
            hasBackdrop: true,
            backdropClass: 'fuse-backdrop-on-mobile',
            scrollStrategy: this._overlay.scrollStrategies.block(),
            positionStrategy: this._overlay.position()
                .flexibleConnectedTo(this._shortcutsOrigin._elementRef.nativeElement)
                .withLockedPosition(true)
                .withPush(true)
                .withPositions([
                    {
                        originX: 'start',
                        originY: 'bottom',
                        overlayX: 'start',
                        overlayY: 'top'
                    },
                    {
                        originX: 'start',
                        originY: 'top',
                        overlayX: 'start',
                        overlayY: 'bottom'
                    },
                    {
                        originX: 'end',
                        originY: 'bottom',
                        overlayX: 'end',
                        overlayY: 'top'
                    },
                    {
                        originX: 'end',
                        originY: 'top',
                        overlayX: 'end',
                        overlayY: 'bottom'
                    }
                ])
        });

        // Detach the overlay from the portal on backdrop click
        this._overlayRef.backdropClick().subscribe(() => {
            this._overlayRef.detach();
        });
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Open the shortcuts panel
     */
    openPanel(): void {
        // Return if the shortcuts panel or its origin is not defined
        //  if ( !this._shortcutsPanel || !this._shortcutsOrigin )
        //  {
        //      return;
        //  }

        // Make sure to start in 'view' mode
        this.mode = 'view';

        // Create the overlay if it doesn't exist
        if (!this._overlayRef) {
            this._createOverlay();
        }

        // Attach the portal to the overlay
        this._overlayRef.attach(new TemplatePortal(this._shortcutsPanel, this._viewContainerRef));
    }

    /**
     * Close the messages panel
     */
    closePanel(): void {
        this._overlayRef.detach();
    }

    reviewClick(vle) {
      this.rvw_vle = vle;
    }
    
    sbmt() {
  
      let postData = {
        rvw_tx: this.sgtn_tx,
        rtng_id: this.rvw_vle,
        enty_ky: this.rvwData.enty_ky,
        hndlr_nm: this.rvwData.hndlr_nm
      }
      if (this.edt_in == 0) {
  
        this._entityService.add_rvw(postData).subscribe((res) => {
          if (res['status'] == 200) {
            this._entityService.openSnackBar(res['message'], 'mat-primary');
            this.get_prvsFdbck(this.rvwData.hndlr_nm, this.rvwData.enty_ky);
          }
          else {
            this._entityService.openSnackBar(res['message'], 'mat-warn');
          }
        })
      }
      else {
        postData['rvw_id']=this.prvsRvwsLst[0].rvw_id;
        this._entityService.updte_rvw(postData).subscribe((res)=>{
          if(res['status'] == 200)
          {
            this._entityService.openSnackBar(res['message'], 'mat-primary');
            this.get_prvsFdbck(this.rvwData.hndlr_nm, this.rvwData.enty_ky);
          }
          else
          {
            this._entityService.openSnackBar(res['message'], 'mat-warn');
          }
        })
      }
  
    }
    get_prvsFdbck(hndlr_nm, enty_ky) {
      this._entityService.get_prvsRvws(hndlr_nm, enty_ky).subscribe((res) => {
        if (res['status'] == 200) {
          if (res['data'].length > 0) {
            this.prvsRvwsLst = res['data']
            this.rvw_vle = this.prvsRvwsLst[0].rtng_id
            this.sgtn_tx = this.prvsRvwsLst[0].rvw_tx
            this.shwPrvsRvw = true;
            this.addRvw = false;
            this.edt_in=0;
            this._changeDetectorRef.markForCheck();
          }
          else {
            this.shwPrvsRvw = false;
            this.addRvw = true;
            this._changeDetectorRef.markForCheck();
          }
  
        }
        else {
          this._entityService.openSnackBar(res['message'], 'mat-warn');
        }
      })
    }
    edtCntct() {
      this.addRvw = true;
      this.shwPrvsRvw = false;
      this.edt_in = 1;
    }
}
